module.exports = __webpack_public_path__ + "img/bt-1.84c5a78b.png";